import {
  LOAD_DEVICE_RESOURCES,
  LOAD_DEVICE_RESOURCES_SUCCESS,
} from "fleet/redux-store/ui-state/device-resources/actions";
import { deviceResourcesService } from "fleet/service/device-resources";
import { createApiSaga } from "redux-store/api-sagas";

const loadDeviceResourcesSaga = createApiSaga({
  fetchAction: LOAD_DEVICE_RESOURCES,
  service: deviceResourcesService.load,
  serviceName: "deviceResourcesService.load",
  successAction: LOAD_DEVICE_RESOURCES_SUCCESS,
  reload: false,
});

export { loadDeviceResourcesSaga };
